import "rxjs/add/observable/throw";
import "rxjs/add/operator/timeoutWith";
import "rxjs/add/operator/toPromise";

import { Injectable } from "@angular/core";
import * as _ from "lodash";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";

import { environment } from "../../environments/environment";
import { ManualApplicationPayment } from "../models/manualApplicationPayment.model";
import { PostedClaimReversal } from "../models/postedClaimReversal.model";
import { RemittanceSplit } from "../models/remittanceSplit.model";
import { ReversalTransaction } from "../models/reversalTransaction.model";
import { BaseService } from "./api-base.service";
import { ReconApiService } from "./recon-api.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class ApplicationService {
  private readonly Timeout: number = 30000;
  constructor(
    private http: HttpClient,
    private apiBase: BaseService,
    private reconApiService: ReconApiService,
  ) {}

  public async postManualApplication<T>(
    clientId: string,
    manualApplicationPayment: ManualApplicationPayment,
  ): Promise<any> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/Actions/ManualApplication/ApplyPaymentAmountToClaim`;
    let response = await this.http
      .post<any>(url, manualApplicationPayment, {
        headers: this.apiBase.getHeaders(),
      })
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded.")),
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`,
        );
        this.reconApiService.logToElasticSearchFromUI(error, url);
      });
    return response;
  }

  public async postSplitRemittanceApplication<T>(
    clientId: string,
    remittanceSplit: RemittanceSplit,
  ): Promise<any> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/Actions/Remittances/QueueSplitRemittances`;
    let response = await this.http
      .post<any>(url, remittanceSplit, {
        headers: this.apiBase.getHeaders(),
        responseType: "text" as "json", // API returns a Ok with no content, but HttpClient expects JSON by default. This forces it to accept a string response.
      })
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded.")),
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`,
        );
        this.reconApiService.logToElasticSearchFromUI(error, url);
      });
    return response;
  }

  public async postReverseTransactionApplication<T>(
    clientId: string,
    reversalTransaction: ReversalTransaction,
  ): Promise<any> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/Actions/ReversalTransaction`;
    let response = await this.http
      .post<any>(url, reversalTransaction, {
        headers: this.apiBase.getHeaders(),
      })
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded.")),
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`,
        );
        this.reconApiService.logToElasticSearchFromUI(error, url);
      });
    return response;
  }

  public async postPostedClaimReversal<T>(
    clientId: string,
    postedClaimReversal: PostedClaimReversal,
  ): Promise<any> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/Actions/Claims/PostedClaims/Reversal`;
    let response = await this.http
      .post<any>(url, postedClaimReversal, {
        headers: this.apiBase.getHeaders(),
        responseType: "text" as "json", // API returns a Ok with no content, but HttpClient expects JSON by default. This forces it to accept a string response.
      })
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded.")),
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`,
        );
        this.reconApiService.logToElasticSearchFromUI(error, url);
      });
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/application.service.ts